import React, { useEffect, useState } from "react";
import moment from "moment";
import config from "../../config";
import axios from "axios";
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Checkbox,
  message,
  Pagination,
  Table,
  Space,
  Tooltip,
  Popconfirm,
  Skeleton,
} from "antd";
import { NavLink } from "react-router-dom";
import LoginChecked from "../Shared/LoginChecked";
import BoxCard from "../Shared/BoxCard";
import { NumberFormat } from "../Shared/Utility";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { SparklesIcon } from "@heroicons/react/24/outline";
import { ArrowDown, ArrowUp, Money, Users } from "../UserControls/Icons";

function CreditSale() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");

  const VoucherMode = "CreditSale";

  const [voucherNo, setVoucherNo] = useState(0);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [StartDate, SetStartDate] = useState("");
  const [EndDate, SetEndDate] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [open, setOpen] = useState(false);
  const [listofVouchers, SetlistofVouchers] = useState([]);
  const [OrderBy, SetOrderBy] = useState("1");
  const [isVoucherUpdated, setIsVoucherUpdated] = useState(false);
  const [Voucherloading, setVoucherloading] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [Button_Lodding, setButton_Lodding] = useState(false);

  const [ModalType, setModalType] = useState("");

  // customer accounts
  const [CustomerAccounts, setCustomerAccounts] = useState([]);
  const [loadingCustomerAccounts, setloadingCustomerAccounts] = useState(false);
  const [CustomerAccount, setCustomerAccount] = useState({});
  const [loadingCustomerAccount, setloadingCustomerAccount] = useState(false);

  // received in
  const [ListOfRecAccounts, setListOfRecAccounts] = useState([]);
  const [loadingRecAccounts, setLoadingRecAccounts] = useState(false);
  const [RecAccountsDropdown, setRecAccountsDropdown] = useState([]);
  const [loadingRecAccount, setLoadingRecAccount] = useState(false);
  const [RecAccount, setRecAccount] = useState({});

  const [debitAccountID, setdebitAccountID] = useState(0);
  const [creditAccountID, setcreditAccountID] = useState(0);
  const [VoucherId, setVoucherId] = useState("");

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);

  const [total, setTotal] = useState(0);
  const [keepOpenForNextEntry, setKeepOpenForNextEntry] = useState(false);

  const fetchNextVoucherNo = () => {
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      VoucherMode: VoucherMode,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "/Voucher/GetNextVoucherNo",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setVoucherNo(response.data.NextVoucherNo);
        }
      })
      .catch(function (error) {});
  };

  useEffect(() => {
    document.title = "Credit Sale Vouchers";
    setIsDeleted(false);
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      StartDate: StartDate,
      EndDate: EndDate,
      OrderBy: OrderBy,
      PageNo: pageNo,
      PageSize: pageSize,
      AccountID: 0,
      Debit_Account_ID: 0,
      Credit_Account_ID: 0,

      VoucherMode: VoucherMode,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "Voucher/GetVouchersWithType",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          SetlistofVouchers(response.data.listofVouchers);
          setTotalRecords(response.data.totalRecords);
          setTotal(response.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {});
  }, [
    OrderBy,
    isVoucherUpdated,
    StartDate,
    EndDate,
    pageSize,
    pageNo,
    isDeleted,
  ]);

  useEffect(() => {
    fetchNextVoucherNo();
  }, [Voucherloading]);

  const fetchAccountsByType = (accountTypeID, setAccounts, setLoading) => {
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      Account_Type_ID: accountTypeID,
    };
    const api_config = {
      method: "post",
      url: `${config.base_url}account/GetAccountsByType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then((response) => {
        if (response.data.status_code === 1) {
          const result = response.data.listofAccounts.map((item) => ({
            value: item.ID,
            label: item.Name,
          }));
          setAccounts(result);
        }
      })
      .catch((error) => {
        console.error("Error fetching accounts:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAccountsByType(2, setRecAccountsDropdown, setLoadingRecAccounts);
  }, []);

  useEffect(() => {
    fetchAccountsByType(-2, setCustomerAccounts, setloadingCustomerAccounts);
  }, []);

  const onSelectDebitAccount = (id) => {
    setdebitAccountID(id);
    setLoadingRecAccount(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: id,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "account/GetAccountbyIDWithBalance",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setRecAccount(response.data);
          setLoadingRecAccount(false);
        } else {
          setLoadingRecAccount(false);
        }
      })
      .catch(function (error) {});
  };

  const onSelectCreditAccount = (item) => {
    setcreditAccountID(item);
    setloadingCustomerAccount(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: item,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "account/GetAccountbyIDWithBalance",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          // Handle success
          // setlistofAccounts(response.data.listofAccounts);
          setCustomerAccount(response.data);
          setloadingCustomerAccount(false);
        } else {
          // Handle error
          setloadingCustomerAccount(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {});
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const columns = [
    {
      title: "SR",
      render: (_, record, index) => index + 1 + pageSize * (pageNo - 1),
      key: "Sr",
    },
    {
      title: "Dated",
      dataIndex: "Dated",
      key: "dated",
      render: (date) => moment(date).format(config.date_format),
      sorter: true,
    },
    {
      title: "No",
      dataIndex: "VoucherNo",
      key: "VoucherNo",
      sorter: true,
    },
    {
      title: "Customer name",
      dataIndex: "Debit_Account",
      key: "Debit_Account",
      render: (_, record) => {
        return record.Debit_Account ? (
          <a
            target="_blank"
            href={`/accounts/account-ledger/?account_id=${record.Debit_Account_ID}`}
          >
            {record.Debit_Account.Name}
          </a>
        ) : (
          ""
        );
      },
    },
    {
      title: "From Account",
      dataIndex: "Credit_Account",
      key: "Credit_Account",
      render: (_, record) => {
        return record.Credit_Account ? (
          <a
            target="_blank"
            href={`/accounts/account-ledger/?account_id=${record.Credit_Account_ID}`}
          >
            {record.Credit_Account.Name}
          </a>
        ) : (
          ""
        );
      },
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "description",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      align: "right",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a type="button" onClick={() => handelShowModal("Edit", record)}>
            <Tooltip title="Edit Voucher">
              <EditOutlined />
            </Tooltip>
          </a>
          <Popconfirm
            title="Sure to delete?"
            description="Are You sure to delete this data"
            onConfirm={() => handelDelete(record.ID)}
          >
            <Tooltip title="Delete Voucher">
              <DeleteOutlined />
            </Tooltip>
          </Popconfirm>
          <NavLink
            to={`/accounts/print-voucher-list/?voucher_id=${record.ID}`}
            target="_blank"
          >
            <Tooltip title="Print Voucher">
              <PrinterOutlined />
            </Tooltip>
          </NavLink>
        </Space>
      ),
    },
  ];

  const handelDelete = (ID) => {
    setIsDeleted(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ID: ID,
    };
    const api_config = {
      method: "post",
      url: config.base_url + "Voucher/DeleteVoucher",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          setIsDeleted(false);
          message.success(response.data.status_message);
        } else {
          setIsDeleted(false);
          message.error(response.data.status_message);
        }
      })
      .catch(function (error) {
        setIsDeleted(false);
      });
  };
  const handleStartDateChange = (date, dateString) => {
    if (!dateString) {
      SetStartDate("");
      setPageNo(1);
      return;
    }
    SetStartDate(dateString);
    setPageNo(1);
    if (EndDate && dayjs(dateString).isAfter(dayjs(EndDate), "day")) {
      SetEndDate(dateString);
    }
  };

  const handleEndDateChange = (date, dateString) => {
    if (!dateString) {
      SetEndDate("");
      setPageNo(1);
      return;
    }
    SetEndDate(dateString);
    setPageNo(1);
    if (StartDate && dayjs(dateString).isBefore(dayjs(StartDate), "day")) {
      SetStartDate(dateString);
    }
  };

  const disableStartDate = (current) => {
    if (!current) return false;
    if (current > moment().endOf("day")) return true;
    if (EndDate && current.isAfter(dayjs(EndDate), "day")) return true;
    return false;
  };

  const disableEndDate = (current) => {
    if (!current) return false;
    if (current > moment().endOf("day")) return true;
    if (StartDate && current.isBefore(dayjs(StartDate), "day")) return true;
    return false;
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    // Make API request with sorting parameters
    const sortField = sorter.field;

    const sortOrder = sorter.order === "descend" ? "desc" : "asc";

    if (sortField == "Dated") {
      if (sortOrder == "asc") {
        SetOrderBy(6);
      } else {
        SetOrderBy(5);
      }
    } else if (sortField == "VoucherNo") {
      if (sortOrder == "asc") {
        SetOrderBy(2);
      } else {
        SetOrderBy(1);
      }
    } else {
    }
  };

  const handelShowModal = (type, record) => {
    setModalType(type);

    if (type === "Edit") {
      onSelectCreditAccount(record.Credit_Account_ID);
      onSelectDebitAccount(record.Debit_Account_ID);
      const data = {
        NextVoucherNo: record.VoucherNo,
        Amount: record.Amount,
        Dated: dayjs(record.Dated),
        Debit_Account_ID: record.Debit_Account?.ID,
        Credit_Account_ID: record.Credit_Account?.ID,
        Description: record.Description,
      };
      form.setFieldsValue(data);
      setVoucherId(record.ID);
      setVoucherNo(record.VoucherNo);
    } else {
      setVoucherloading(false);
    }

    setOpen(true);
  };

  const handleCancel = () => {
    setSelectedVoucher(null);
    setOpen(false);
    setButton_Lodding(false);
    setKeepOpenForNextEntry(false);
    setVoucherloading(true);
    form.resetFields();
    setVoucherId("");

    setcreditAccountID(0);
    setdebitAccountID(0);

    setRecAccount({ Balance: 0, BalanceType: "" });
    setCustomerAccount({ Balance: 0, BalanceType: "" });
  };
  const handelVoucher = (formData) => {
    setIsVoucherUpdated(true); // Corrected line
    setButton_Lodding(true);
    setLoading(true);

    formData["Dated"] = dayjs(formData["Dated"]).format("YYYY-MM-DD");

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      VoucherMode: VoucherMode,

      Credit_Account_ID: creditAccountID,
      Debit_Account_ID: debitAccountID,

      ...formData,
    };

    if (ModalType === "Edit") {
      data.ID = VoucherId;
    }

    const api_config = {
      method: "post",
      url:
        config.base_url +
        (ModalType === "Edit"
          ? "Voucher/UpdateVoucher"
          : "Voucher/AddNewVoucher"),
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          if (ModalType === "Add") {
            if (keepOpenForNextEntry) {
              const fromAccountId = form.getFieldValue("Credit_Account_ID");
              const givenToId = form.getFieldValue("Debit_Account_ID");
              const currentDate = form.getFieldValue("Dated");
              form.setFieldsValue({
                Amount: undefined,
                Description: "",
                Dated: currentDate || dayjs(),
                Credit_Account_ID: fromAccountId,
                Debit_Account_ID: givenToId,
              });
              if (fromAccountId) {
                setdebitAccountID(fromAccountId);
                onSelectDebitAccount(fromAccountId);
              }
              if (givenToId) {
                setcreditAccountID(givenToId);
                onSelectCreditAccount(givenToId);
              }
              fetchNextVoucherNo();
              setVoucherloading(true);
            } else {
              handleCancel();
            }
          } else if (ModalType === "Edit") {
            setOpen(false);
            setRecAccount({ Balance: 0, BalanceType: "" });
            setCustomerAccount({ Balance: 0, BalanceType: "" });
            form.resetFields();
          }
          setIsVoucherUpdated(false);
          setButton_Lodding(false);
          setLoading(false);
          messageApi.open({
            type: "success",
            content: response.data.status_message,
          });

          setConfirmLoading(false);

          if (!(ModalType === "Add" && keepOpenForNextEntry)) {
            setVoucherloading(true);
          }
        } else {
          setLoading(false);
          setButton_Lodding(false);
          messageApi.open({
            type: "error",
            content: response.data.status_message,
          });
        }
      })
      .catch(function (error) {
        setLoading(false);
        setButton_Lodding(false);
        messageApi.open({
          type: "error",
          content: "Network Error",
        });
      });
  };

  return (
    <>
      {contextHolder}
      <Modal
        title={ModalType == "Edit" ? "Update Voucher" : "Add Credit Sale"}
        open={open}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={handelVoucher}
          autoComplete="off"
          form={form}
        >
          <Row align="bottom" gutter={24}>
            <Col xs={24} md={6}>
              <Form.Item
                className="input-vertical"
                label="Voucher No"
                rules={[{ required: true }]}
              >
                <Input disabled value={voucherNo} />
              </Form.Item>
            </Col>
            <Col xs={24} md={9}>
              <Form.Item
                className="input-vertical"
                name="Amount"
                label="Amount"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={9}>
              <Form.Item
                className="input-vertical"
                name="Dated"
                label="Date"
                rules={[{ required: true }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="From Account"
                name="Credit_Account_ID"
                className="input-vertical"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select Account"
                  optionFilterProp="children"
                  onChange={onSelectDebitAccount}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={loadingRecAccounts}
                  options={RecAccountsDropdown}
                />
              </Form.Item>
              {loadingRecAccounts ? (
                <>
                  <p>
                    <Skeleton.Input style={{ width: 150, height: 40 }} active />
                  </p>
                </>
              ) : (
                <>
                  <p style={{ textAlign: "Left", marginTop: 0 }}>
                    <span className="lbl">Current Balance </span>
                    <span className="val balance">
                      Rs. <strong>{NumberFormat(RecAccount.Balance, 0)}</strong>{" "}
                      {RecAccount.BalanceType}
                    </span>
                  </p>
                </>
              )}
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                rules={[{ required: true }]}
                label="Given To"
                name="Debit_Account_ID"
                className="input-vertical"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                <Select
                  showSearch
                  placeholder="Select Account"
                  optionFilterProp="children"
                  onChange={onSelectCreditAccount}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={loadingCustomerAccounts}
                  options={CustomerAccounts}
                />
              </Form.Item>
              {loadingCustomerAccounts ? (
                <>
                  <p>
                    <Skeleton.Input style={{ width: 150, height: 40 }} active />
                  </p>
                </>
              ) : (
                <>
                  <p style={{ textAlign: "Left", marginTop: 0 }}>
                    <span className="lbl">Current Balance </span>
                    <span className="val balance">
                      Rs.{" "}
                      <strong>
                        {NumberFormat(CustomerAccount.Balance, 0)}
                      </strong>{" "}
                      {CustomerAccount.BalanceType}
                    </span>
                  </p>
                </>
              )}
            </Col>
            <Col span={12} xs={24} md={24} style={{ position: "relative" }}>
              <Button
                shape="circle"
                type="text"
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "0",
                  zIndex: "1",
                }}
                disabled={
                  !form.getFieldValue("Amount") ||
                  !form.getFieldValue("Debit_Account_ID") ||
                  !form.getFieldValue("Credit_Account_ID") ||
                  !form.getFieldValue("Dated")
                }
                onClick={() => {
                  const amount = form.getFieldValue("Amount") || 0;
                  const currentDate = dayjs(form.getFieldValue("Dated")).format(
                    "YYYY-MM-DD"
                  );
                  const debitAccount =
                    CustomerAccounts.find(
                      (acc) =>
                        acc.value === form.getFieldValue("Debit_Account_ID")
                    )?.label || "Debit Account";
                  const creditAccount =
                    RecAccountsDropdown.find(
                      (acc) =>
                        acc.value === form.getFieldValue("Credit_Account_ID")
                    )?.label || "Credit Account";
                  const autoDescription = `Credit Sales of Rs. ${amount} recorded, debited in ${debitAccount} account and credited from ${creditAccount} on ${dayjs(
                    currentDate
                  ).format("DD MMM YYYY")}.`;
                  form.setFieldsValue({ Description: autoDescription });
                }}
              >
                <Tooltip title="Genrate with AI">
                  <SparklesIcon width={20} color="#4e3efa" />
                </Tooltip>
              </Button>
              <Form.Item name="Description" label="Description">
                <Input />
              </Form.Item>
            </Col>
            {ModalType === "Add" && (
              <Col span={24}>
                <Checkbox
                  checked={keepOpenForNextEntry}
                  onChange={(e) => setKeepOpenForNextEntry(e.target.checked)}
                >
                  After save, keep this window open and keep the same accounts
                  selected (for entering another voucher)
                </Checkbox>
              </Col>
            )}
            <Col span={24}>
              <div className="text-right">
                <Button
                  type="primary"
                  size="large"
                  shape="round"
                  loading={Button_Lodding}
                  htmlType="submit"
                >
                  {ModalType == "Edit"
                    ? "Update Credit Sale"
                    : "Add Credit Sale"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">Credit Sales</h3>
            <div className="header-actions">
              <NavLink
                to={`/vouchers/print-voucher-details/?StartDate=${StartDate}&EndDate=${EndDate}&AccountID=${0}&VoucherMode=${VoucherMode}&DebitAccountID=${0}&creditAccountID=${0}`}
                target="blank"
              >
                <Button
                  type="dashed"
                  shape="round"
                  size="large"
                  icon={<PrinterOutlined />}
                >
                  Download / Print
                </Button>
              </NavLink>
              <Button
                type="primary"
                size="large"
                shape="round"
                icon={<PlusOutlined />}
                onClick={() => handelShowModal("Add", {})}
              >
                Add Voucher
              </Button>
            </div>
          </div>

          <div className="card-total-detal">
            <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Total Vouchers"
                  amount={total.TotalVouchers}
                  icon={<Users />}
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Debits Count"
                  amount={total.DebitCount}
                  icon={<ArrowDown />}
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Credits Count"
                  amount={total.CreditCount}
                  icon={<ArrowUp />}
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Total Amount"
                  prefix="Rs."
                  amount={total.Total}
                  icon={<Money />}
                />
              </Col>
            </Row>
          </div>

          <div className="filters-wrap">
            <Form>
              <Form.Item name="StartDate">
                <DatePicker
                  placeholder="Start Date"
                  style={{ width: 150 }}
                  value={StartDate ? dayjs(StartDate) : null}
                  onChange={handleStartDateChange}
                  disabledDate={disableStartDate}
                  allowClear
                />
              </Form.Item>

              <Form.Item name="EndDate">
                <DatePicker
                  placeholder="End Date"
                  style={{ width: 150 }}
                  value={EndDate ? dayjs(EndDate) : null}
                  onChange={handleEndDateChange}
                  disabledDate={disableEndDate}
                  allowClear
                />
              </Form.Item>
            </Form>
          </div>

          <Table
            size="small"
            columns={columns}
            dataSource={listofVouchers}
            pagination={false}
            loading={loading}
            onChange={handleTableChange}
            bordered
            summary={(pageData) => {
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={6} align="right">
                    <b>Total Amount:</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right">
                    {total.Total}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
            scroll={{
              x: "100%",
            }}
          />

          <div className="text-end mt-5">
            <Pagination
              current={pageNo}
              pageSize={pageSize}
              size="small"
              total={totalRecords}
              onChange={(page) => setPageNo(page)}
              onShowSizeChange={(current, size) => {
                setPageNo(1);
                setPageSize(size);
              }}
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default CreditSale;
